export const defaultPageSize = 20;

export const VIRTUALIZED_ROW_DEFAULT_SIZE = 50;
